import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Trust() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de confidentialité</h1>
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <p className="text-lg font-semibold mt-6">Sibyagence, société propriétaire de la plateforme Sibystock (sibystock.com)</p>
          
          <p className="mt-4">
            Sibyagence accorde une grande importance à la confidentialité et à la protection des données personnelles de ses utilisateurs. 
            Cette politique détaille les informations collectées, leur usage et les droits des utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD).
          </p>

          <h2 className="text-2xl font-bold mt-8">1. Responsable du traitement des données</h2>
          <p>
            Le responsable du traitement des données personnelles est :<br />
            Sibyagence<br />
            Email : contact@sibyagence.com
          </p>

          <h2 className="text-2xl font-bold mt-8">2. Données collectées</h2>
          <p>Nous collectons des données personnelles lorsque vous utilisez nos services ou interagissez avec notre plateforme.</p>

          <h3 className="text-xl font-semibold mt-6">2.1. Données collectées directement</h3>
          <ul className="list-disc pl-6">
            <li>Identité : Nom, prénom, adresse e-mail, numéro de téléphone.</li>
            <li>Informations de paiement : Détails bancaires nécessaires pour effectuer des transactions.</li>
            <li>Informations de connexion : Identifiants de compte, mots de passe (cryptés).</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6">2.2. Données collectées automatiquement</h3>
          <ul className="list-disc pl-6">
            <li>Informations techniques : Adresse IP, type de navigateur, système d'exploitation, pages visitées.</li>
            <li>Cookies et technologies similaires : Suivi des interactions avec le site pour améliorer l'expérience utilisateur.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">3. Finalités de la collecte des données</h2>
          <p>Les données collectées sont utilisées pour :</p>
          <ul className="list-disc pl-6">
            <li>Fournir les services proposés sur Sibystock (gestion des stocks, suivi des performances, etc.),</li>
            <li>Assurer la sécurité et le bon fonctionnement de la plateforme,</li>
            <li>Personnaliser l'expérience utilisateur,</li>
            <li>Traiter les paiements et gérer les abonnements,</li>
            <li>Envoyer des notifications et des mises à jour sur nos services,</li>
            <li>Respecter les obligations légales et réglementaires.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">4. Base légale du traitement</h2>
          <p>Le traitement de vos données repose sur :</p>
          <ul className="list-disc pl-6">
            <li>L’exécution d’un contrat (par exemple, abonnement à nos services),</li>
            <li>Le consentement explicite (par exemple, pour l’envoi de newsletters),</li>
            <li>Le respect d’obligations légales,</li>
            <li>Les intérêts légitimes de Sibyagence (par exemple, pour améliorer nos services).</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">5. Partage des données</h2>
          <p>Les données collectées sont strictement confidentielles et ne sont pas vendues. Elles peuvent être partagées uniquement avec :</p>
          <ul className="list-disc pl-6">
            <li>Nos prestataires techniques (hébergement, traitement des paiements) dans le cadre de l’exécution des services,</li>
            <li>Les autorités compétentes si requis par la loi.</li>
          </ul>
          <p>Tous les tiers partenaires respectent les obligations de confidentialité et de protection des données.</p>

          <h2 className="text-2xl font-bold mt-8">6. Conservation des données</h2>
          <p>Les données sont conservées aussi longtemps que nécessaire pour les finalités mentionnées, notamment :</p>
          <ul className="list-disc pl-6">
            <li>Données liées au compte utilisateur : Jusqu’à la suppression du compte,</li>
            <li>Données financières : Conformément aux obligations légales de conservation,</li>
            <li>Cookies : Durée maximale de 13 mois après leur collecte.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">7. Droits des utilisateurs</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <h3 className="text-xl font-semibold mt-6">7.1. Droit d’accès</h3>
          <p>Vous pouvez demander une copie des données personnelles que nous détenons.</p>

          <h3 className="text-xl font-semibold mt-6">7.2. Droit de rectification</h3>
          <p>Vous pouvez corriger ou mettre à jour vos informations personnelles.</p>

          <h3 className="text-xl font-semibold mt-6">7.3. Droit à l’effacement</h3>
          <p>Vous pouvez demander la suppression de vos données personnelles, sauf si leur conservation est requise par la loi.</p>

          <h3 className="text-xl font-semibold mt-6">7.4. Droit à la limitation</h3>
          <p>Vous pouvez demander que nous limitions le traitement de vos données dans certaines circonstances.</p>

          <h3 className="text-xl font-semibold mt-6">7.5. Droit à la portabilité</h3>
          <p>Vous avez le droit de recevoir vos données personnelles dans un format structuré et lisible par machine.</p>

          <h3 className="text-xl font-semibold mt-6">7.6. Droit d’opposition</h3>
          <p>Vous pouvez vous opposer au traitement de vos données pour des raisons légitimes, notamment en cas de marketing direct.</p>

          <p>Pour exercer vos droits, contactez-nous à contact@sibyagence.com. Une réponse sera apportée dans un délai maximum d’un mois.</p>

          <h2 className="text-2xl font-bold mt-8">8. Sécurité des données</h2>
          <p>Nous mettons en œuvre des mesures techniques et organisationnelles strictes pour protéger vos données contre l’accès non autorisé, la perte, la modification ou la divulgation :</p>
          <ul className="list-disc pl-6">
            <li>Chiffrement des données sensibles,</li>
            <li>Systèmes de pare-feu et de détection d’intrusion,</li>
            <li>Accès limité aux données aux seules personnes autorisées.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">9. Cookies et technologies similaires</h2>
          <h3 className="text-xl font-semibold mt-6">9.1. Définition des cookies</h3>
          <p>Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous visitez un site web.</p>

          <h3 className="text-xl font-semibold mt-6">9.2. Finalité des cookies</h3>
          <p>Nous utilisons des cookies pour :</p>
          <ul className="list-disc pl-6">
            <li>Analyser le trafic sur notre site,</li>
            <li>Améliorer votre expérience utilisateur,</li>
            <li>Mémoriser vos préférences.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6">9.3. Gestion des cookies</h3>
          <p>Lors de votre première visite sur le site, vous pouvez accepter ou refuser l’utilisation des cookies non essentiels via une bannière dédiée. Vous pouvez également les gérer via les paramètres de votre navigateur.</p>

          <h2 className="text-2xl font-bold mt-8">10. Modifications de la politique de confidentialité</h2>
          <p>Nous nous réservons le droit de modifier cette politique pour refléter les évolutions légales, techniques ou commerciales. Toute modification sera communiquée via le site ou par email, avec un préavis si nécessaire.</p>

          <h2 className="text-2xl font-bold mt-8">11. Contact</h2>
          <p>
            Pour toute question ou réclamation relative à cette politique de confidentialité ou à vos données personnelles, 
            veuillez nous contacter :
          </p>
          <p>Email : contact@sibyagence.com</p>
        </div>
      </main>
    </div>
  );
}
